module.exports = __webpack_public_path__ + "img/3.31ec2fc1.png";